// 平台商戶映射（YYC 直播試貨平台）：products.brand（slug）→ 商戶顯示名
// 滾水6腳＝首個入駐品牌（旗艦）；其餘為直播嚴選引進品牌。日後入駐品牌加這裡。
export const BRAND_LABELS: Record<string, string> = {
  gs6j: '滾水6腳',
  mankee: '文記',
  'slice chili': '素椒醬',
  x1493: 'X-1493 辣谷',
  'mama soup': '阿媽靚湯',
  aobo: '澳寶牌',
  dingtong: '頂湯',
  shengjia: '盛佳佳茂',
};

export function brandLabel(slug: string | undefined | null): string {
  if (!slug) return '';
  return BRAND_LABELS[slug] || slug;
}

// 【2026-09-09 shipping-zones v2】只限香港本地配送判定改由「定性配對」驅動（單一真理源）：
// 類目 → 物流定性（naturesStore，源自 /api/public/shipping/natures-map）；
// 定性 cold_chain（冷鏈）／alcohol（酒類）＝只限香港——海外區白名單不含它們即自動 HK-only。
// 載入前／失敗時以 9/4 靜態清單保守 fallback，對外行為（🇭🇰 badge／Checkout 硬阻）與 9/4 一致。
import { useNaturesStore } from '../store/naturesStore';

const LOCAL_ONLY_NATURES = new Set(['cold_chain', 'alcohol']);
const LEGACY_LOCAL_ONLY_SLUGS = new Set(['kung-heated', 'kung-frozen', 'kung-wonton', 'alcohol']);

export function isLocalOnlyNatureCode(code: string | null | undefined): boolean {
  return !!code && LOCAL_ONLY_NATURES.has(code);
}

export function categoryNatureCode(category: string | undefined | null): string | undefined {
  if (!category) return undefined;
  return useNaturesStore.getState().categories[category];
}

export function productNatureCode(productId: number): string | undefined {
  return useNaturesStore.getState().products[productId];
}

export function isLocalOnlyCategory(category: string | undefined | null): boolean {
  if (!category) return false;
  const st = useNaturesStore.getState();
  if (st.loaded) return isLocalOnlyNatureCode(st.categories[category]);
  return LEGACY_LOCAL_ONLY_SLUGS.has(category); // natures-map 未就緒的保守 fallback（9/4 行為）
}
